import { encodeFormUrl } from "./urlEncoder";

// The public link to a form, as the Share tab shows it. The server builds the
// same link for reminder emails (formShareUrl in
// src/backend_routes/lib/reminders.js); shareLink.test.js keeps them equal.
// The form id is always encoded as a number, however the page got it.
export function formShareUrl(origin, formId) {
    const id = /^\d+$/.test(String(formId)) ? Number(formId) : formId;
    return `${String(origin).replace(/\/+$/, "")}/forms/${encodeFormUrl(id, "start")}`;
}

// Share by email: a mailto: link with the form's title and link.
export function emailShareHref(title, link) {
    const name = (title || "").trim() || "a form";
    const subject = `Please fill in: ${name}`;
    const body = `Hi,\n\nPlease fill in "${name}":\n${link}\n\nThank you.`;
    return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

// Share on WhatsApp: https://wa.me/?text=<title and link, URL-encoded>.
export function whatsappShareHref(title, link) {
    const name = (title || "").trim() || "Form";
    return `https://wa.me/?text=${encodeURIComponent(`${name}\n${link}`)}`;
}

// File name for the downloaded QR code: "QR_<title>.png".
export function qrFileName(title) {
    const safe = String(title || "").replace(/[^a-z0-9]+/gi, "_").replace(/^_+|_+$/g, "").slice(0, 60);
    return `QR_${safe || "form"}.png`;
}
